const Strings = {
  install (Vue, options) {
    Vue.prototype.$Strings = (key) => {
      if (window.drupalSettings && window.drupalSettings.gsoidstrings && window.drupalSettings.gsoidstrings[key]) {
        return window.drupalSettings.gsoidstrings[key]
      } else {
        return key
      }
    }
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/strings.js